import { RevisionHistoryKind, RevisionParticipant } from './response.types'

export const PAYMENT_TICKET_API = '/api/internal/payment-ticket'

export const PARTICIPANT_LABEL: Record<RevisionParticipant, string> = {
  DEPOSIT_MERCHANT: 'Мерчант пополнения',
  PAYOUT_MERCHANT: 'Мерчант выплаты',
  COUNTERPARTY: 'Касса или провайдер',
  PLATFORM: 'Платформа',
}

export const KIND_LABEL: Record<RevisionHistoryKind, string> = {
  storno: 'Сторно',
  upward_revision: 'Доначисление',
  correction: 'Корректировка',
}
